import {
  GET_AVAILABILITY_STORES_FAILED,
  GET_AVAILABILITY_STORES_START,
  GET_AVAILABILITY_STORES_SUCCESS,
  TOGGLE_GET_AVAILABILITY_STORES_LOADING
} from './types';

/** @param {Object} payload
 * @param {Number} payload.Type 0: OR; 1: AND
 * @param {Array} payload.ListProducts products list with properties: ProductId: string; VariantId: string; Threshold: number
 * @param {Array} payload.FreeGiftsList
 */
export const getAvailabilityStoresStart = (payload) => (
  {
    type: GET_AVAILABILITY_STORES_START,
    payload: {
      ...payload,
      FreeGiftsList: payload.FreeGiftsList ?? []
    }
  }
);

export const getAvailabilityStoresSuccess = (payload) => (
  {
    type: GET_AVAILABILITY_STORES_SUCCESS,
    payload
  }
);

export const getAvailabilityStoresFailed = (payload) => (
  {
    type: GET_AVAILABILITY_STORES_FAILED,
    payload
  }
);

export const toggleGetAvailabilityStoresLoading = (payload) => (
  {
    type: TOGGLE_GET_AVAILABILITY_STORES_LOADING,
    payload
  }
);